export function gtmEvent(event: string) {
	window['dataLayer'] = window['dataLayer'] || []

	window['dataLayer'].push({
		event,
	})
}
